import { Component, OnInit } from '@angular/core';
import { ReportFileService } from '../../shared/report-file.service';
import { ReportInfoDto } from '../../shared/dto/report-info.dto';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { StandardReportDto } from '../../shared/dto/standard-report.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-report-standard-report-files',
  templateUrl: './report-standard-report-files.component.html',
  styleUrl: './report-standard-report-files.component.less',
    standalone: false
})
export class ReportStandardReportFilesComponent implements OnInit {
  public standardReports = new Array<StandardReportDto>();
  public selectedCount: number = 0;
  public selectAll: boolean = false;
  public searching = false;
  constructor(
    private _reportFileService: ReportFileService,
    private _configService: ConfigServiceService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.searching = true;
    this._configService
      .getTableFriendlyStandardReports()
      .then((result) => {
        this.standardReports = result;
        this.searching = false;
      })
      .catch((err) => {
        this._notificationService.httpError(err);
        this.searching = false;
      });
  }

  public handleDownloadClick(reportName: string): void {
    this._reportFileService.downloadStandardReport(reportName);
  }

  public handleDownloadMultipleReportsClick(): void {
    let selectedReports = this.standardReports.filter((x) => x.Selected);

    for (let report of selectedReports) {
      this._reportFileService.downloadStandardReport(report.ReportFileName);
    }
  }

  public setSelectedCount() {
    this.selectedCount = this.standardReports.filter((x) => x.Selected).length;
  }

  public handleSelectAll() {
    for (let report of this.standardReports) {
      report.Selected = !this.selectAll;
    }

    this.selectAll = !this.selectAll;
    this.setSelectedCount();
  }
}
